/* unplugin-vue-components disabled */import { render } from "./consultingService.vue?vue&type=template&id=e60affd4&scoped=true"
import script from "./consultingService.vue?vue&type=script&lang=js"
export * from "./consultingService.vue?vue&type=script&lang=js"

import "./consultingService.vue?vue&type=style&index=0&id=e60affd4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.15_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e60affd4"]])

export default __exports__